import React, { useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  // flexRender,
} from "@tanstack/react-table";
import {
  // ChevronDown,
  // ChevronLeft,
  // ChevronRight,
  // ChevronUp,
  Search,
  X,
} from "lucide-react";
import { DataGrid } from "../DataGrid";
import {
  Card,
  CardFooter,
  CardHeader,
  CardHeading,
  CardTable,
  CardTitle,
  CardToolbar,
} from "../Card";
import { Input } from "../Input";
import { Button } from "../Button";
import { ScrollArea, ScrollBar } from "../ScrollArea";
// import { DataGridPagination } from "../DataGridPagination";
import { DataGridTable } from "../DataGridTable";
// import GlobalPagination from "utils/GlobalPagination";
import { PaginationComponent } from "components/atoms";
import { DataGridPagination } from "../DataGridPagination";

const TableContainer = ({
  columns,
  data,
  title = "",
  isPagination = true,
  recordCount = 0,
  isGlobalFilter = true,
  onSearch = () => {},
  onUpdatePagination = () => {},
  onUpdateSort = () => {},
  extraButton = <></>,
  hasSearch = false,
  totalPages,
  paginationState = { pageIndex: 0, pageSize: 10 },
  customSorting = false,
}) => {
  const [pagination, setPagination] = useState(
    !isPagination ? paginationState : { pageIndex: 0, pageSize: 10 },
  );

  const [sorting, setSorting] = useState([{ id: "lastModified", desc: true }]);

  const table = useReactTable({
    columns,
    data: data,
    pageCount: Math.ceil(
      (recordCount ? recordCount : data?.length ? data?.length : 0) /
        paginationState?.pageSize,
    ),
    getRowId: (row) => row.id,
    state: {
      pagination: !isPagination ? paginationState : pagination,
      sorting,
    },
    onSortingChange: (e) => {
      setSorting(e);
      if (customSorting) {
        onUpdateSort(e());
      }
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    manualPagination: !isPagination,
    manualSorting: true,
  });

  const [searchQuery, setSearchQuery] = useState("");

  return (
    <DataGrid
      table={table}
      recordCount={recordCount ? recordCount : data?.length ? data?.length : 0}
      tableLayout={{
        columnsPinnable: true,
        columnsMovable: true,
        columnsVisibility: false,
        cellBorder: true,
      }}
    >
      <Card className="min-w-full">
        <CardHeader className="py-3 flex-wrap gap-2">
          <CardHeading>
            <CardTitle>
              <div className="flex gap-3 items-center z-0">
                {title && title}
                {hasSearch && (
                  <div className="absolute">
                    <Search className=" size-4  z-10 text-muted-foreground absolute start-3 top-1/2 -translate-y-1/2" />
                    <Input
                      placeholder={`Search ${title}`}
                      value={searchQuery}
                      onChange={(e) => {
                        if (onSearch) {
                          onSearch(e.target.value);
                        }
                        setSearchQuery(e.target.value);
                      }}
                      inputClassName="px-8"
                      className="w-50"
                    />
                    {searchQuery.length > 0 && (
                      <Button
                        mode="icon"
                        variant="ghost"
                        className="absolute end-1.5 top-1/2 -translate-y-1/2 h-6 w-6"
                        onClick={() => {
                          if (onSearch) {
                            onSearch("");
                          }
                          setSearchQuery("");
                        }}
                      >
                        <X />
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </CardTitle>
          </CardHeading>
          <CardToolbar>
            {isGlobalFilter && (
              <div className="relative">
                <Search className="size-4 text-muted-foreground absolute start-3 top-1/2 -translate-y-1/2" />
                <Input
                  placeholder="Search by ID"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="ps-9 w-40"
                />

                {searchQuery.length > 0 && (
                  <Button
                    mode="icon"
                    variant="ghost"
                    className="absolute end-1.5 top-1/2 -translate-y-1/2 h-6 w-6"
                    onClick={() => setSearchQuery("")}
                  >
                    <X />
                  </Button>
                )}
              </div>
            )}
            {extraButton}
          </CardToolbar>
        </CardHeader>
        <CardTable>
          <ScrollArea>
            <DataGridTable />
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        </CardTable>
        <CardFooter>
          {isPagination ? (
            <DataGridPagination />
          ) : (
            <PaginationComponent
              limit={paginationState?.pageSize}
              currentPageNo={paginationState?.pageIndex + 1}
              onChangePagination={(size, page) => {
                onUpdatePagination(size, page);
              }}
              total={recordCount}
              totalPage={totalPages}
            />
          )}
        </CardFooter>
      </Card>
    </DataGrid>
  );
};

export default TableContainer;
